
export class VisualFieldNotAllowedReason {
  constructor(public readonly message: string) { }
}

export namespace VisualFieldNotAllowedReason {
  export const
    DisabledRole = new VisualFieldNotAllowedReason(`The role is disabled`),
    ValuesNotAllowed = new VisualFieldNotAllowedReason(`The role does not allow values`),
    MeasuresNotAllowed = new VisualFieldNotAllowedReason(`The role does not allow measures`),
    LimitReached = new VisualFieldNotAllowedReason(`The role has reached field limit`),
    DuplicateField = new VisualFieldNotAllowedReason(`The role does not allow duplicate field`),
    NoRoleFound = new VisualFieldNotAllowedReason(`No suitable role found`),
    InvalidType = new VisualFieldNotAllowedReason(`Invalid type`);
}

export const VisualFieldAllowed: VisualFieldNotAllowedReason = null;
